import { create } from 'zustand'
import { api } from '../lib/api'

interface AuthState {
  user: { id: string; email: string; role: string; displayName: string | null; preferredLang: string } | null
  loading: boolean
  initialized: boolean
  login: (email: string, password: string) => Promise<void>
  register: (email: string, password: string, displayName?: string) => Promise<void>
  logout: () => Promise<void>
  checkAuth: () => Promise<void>
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  loading: false,
  initialized: false,

  checkAuth: async () => {
    try {
      set({ loading: true })
      const res = await api.getMe()
      set({ user: res.data, initialized: true, loading: false })
    } catch {
      set({ user: null, initialized: true, loading: false })
    }
  },

  login: async (email, password) => {
    set({ loading: true })
    try {
      const res = await api.login(email, password) as any
      set({ user: res.data, loading: false })
    } catch (e) {
      set({ loading: false })
      throw e
    }
  },

  register: async (email, password, displayName) => {
    set({ loading: true })
    try {
      const res = await api.register(email, password, displayName) as any
      set({ user: res.data, loading: false })
    } catch (e) {
      set({ loading: false })
      throw e
    }
  },

  logout: async () => {
    await api.logout().catch(() => {})
    set({ user: null })
  },
}))
